import { DatePipe } from '@angular/common'
import { RouterLink } from '@angular/router'
import { AfterViewInit, ChangeDetectionStrategy, Component, inject, input, numberAttribute, OnChanges } from '@angular/core'
import { NgIcon, provideIcons } from '@ng-icons/core'
import { bootstrapChevronDown } from '@ng-icons/bootstrap-icons'
import { Dictionary } from '../filtering-search-component-base/filtering-search-types'
import { expandCollapse, openClose } from '../../animations/open-close-animations'
import { SafeHtmlPipe } from '../../pipes/safehtml.pipe'

@Component({
  selector: 'situation-timeline',
  imports: [
    DatePipe,
    RouterLink,
    NgIcon,
    SafeHtmlPipe
  ],
  providers: [
    provideIcons({
      bootstrapChevronDown
    }),
  ],
  templateUrl: './situation-timeline.component.html',
  styleUrl: './situation-timeline.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    openClose,
    expandCollapse,
  ],
})
export class SituationTimelineComponent implements OnChanges, AfterViewInit {

  public timeline = input.required<any[]>()
  public highlightSituationID = input(0, {transform: numberAttribute})
  public linkall = input<boolean>(false)
  public expandAllDistressed = input<boolean>(false)
  public isTimeLineExpanded: Dictionary<boolean> = {}
  public animationDisabled = true

  private datePipe = inject(DatePipe)

  createTimeLineEntrySummary(situationTimelineArray: any[]): string {
    let result = ''

    if (situationTimelineArray.length > 0) {
      const firstEntryByDate = situationTimelineArray[situationTimelineArray.length - 1]
      if (firstEntryByDate.reasonIDs[0] < 1000) {
        result = '<strong>Bankruptcy:</strong>&nbsp;'
      } else {
        result = '<strong>Distressed:</strong>&nbsp;'
      }
      result = result + this.datePipe.transform(firstEntryByDate.date) + '&nbsp;'

      if (situationTimelineArray.length > 1) {
        result = result + ' - ' + this.datePipe.transform(situationTimelineArray[0].date)
      }

      if (firstEntryByDate.leadCaseName) {
        result = `${result} (Lead case: ${firstEntryByDate.leadCaseName})`
      }
    }
    return result
  }

  ngOnChanges() {
    this.isTimeLineExpanded = {
      [this.highlightSituationID()]: true
    }

    if (this.expandAllDistressed()) {
      this.timeline().forEach((situationTimeline) => {
        if (situationTimeline.entries[0].reasonID >= 1000) {
          this.isTimeLineExpanded[situationTimeline.id] = true
        }
      })
    }
    this.animationDisabled = true
    setTimeout(() => {
      this.animationDisabled = false
    }, 200)
  }

  ngAfterViewInit(): void {
    this.animationDisabled = false
}

}
